import React from "react";

export function GoLiveNotes() {
  return (
    <div className="rounded-2xl border p-4 bg-gray-50">
      <h3 className="text-lg font-semibold mb-2">How to Launch Safely</h3>
      <ol className="list-decimal pl-5 text-sm space-y-1">
        <li>
          Keep monitoring in <strong>TEST</strong> for a 24-hour burn-in.
        </li>
        <li>
          Confirm at least one notification channel delivers (Slack/Email).
        </li>
        <li>
          Verify no unhandled exceptions; p95 &lt; 2000 ms; timeout rate &lt;
          5%.
        </li>
        <li>Set Stripe LIVE keys &amp; price IDs only when ready to charge.</li>
        <li>
          Flip <code>BILLING_ALERTS_MODE=LIVE</code> after burn-in passes.
        </li>
      </ol>
      <p className="text-xs text-gray-600 mt-2">
        Rollback: set <code>BILLING_ALERTS_MODE=TEST</code> and redeploy
        previous tag; keep logs for post-mortem.
      </p>
    </div>
  );
}
